import React, { useState, useEffect } from "react";
import "./styles.css";

const imageData = [
  { file: "badlands.jpg", alt: "Badlands National Park, South Dakota, USA" },
  { file: "roxborough.JPG", alt: "Roxborough State Park, Colorado, USA" },
  { file: "lajolla.JPG", alt: "La Jolla, California, USA" },
  { file: "yosemite.jpg", alt: "Yosemite National Park, California, USA" },
  { file: "deathvalley.jpg", alt: "Death Valley National Park, California, USA" },
  { file: "cabo.JPG", alt: "Cabo San Lucas, Baja California Sur, Mexico" },
  { file: "maui.jpg", alt: "Makena Beach, Maui, Hawaii, USA" },
  { file: "marienplatz.jpg", alt: "Marienplatz, Munich, Germany" },
  { file: "neuschwanstein.jpg", alt: "Neuschwanstein Schloss, Schwangau, Germany" },
  { file: "hallstatt.jpg", alt: "Hallstatt, Upper Austria, Austria" },
  { file: "olympiastadion.jpg", alt: "Olympic Park, Munich, Germany" },
  { file: "salzburg.jpg", alt: "Salzburg, Austria" },
  { file: "coronado.jpeg", alt: "Coronado Hotel, San Diego, California, USA" },
  { file: "elmorro.jpeg", alt: "Castillo San Felipe Del Morro, San Juan, Puerto Rico, USA" },
  { file: "oldsouthchurch.jpeg", alt: "Old South Church, Boston, Massachusetts, USA" },
  { file: "boston.jpeg", alt: "Old State House, Boston, Massachusetts, USA" },
  { file: "pabe_ghat.png", alt: "Pabe Ghat, Maharashtra, India" },
  { file: "la_jolla_cove.png", alt: "La Jolla Cove, San Diego, California, USA" },
  { file: "daytona.png", alt: "Daytona International Speedway, Daytona, Florida, USA" },
  { file: "georgetown.png", alt: "Healey Hall, Georgetown University, Washington DC, USA" },
  { file: "washington_monument.png", alt: "Washington Monument, Washington DC, USA" },
  { file: "acorn_street.png", alt: "Acorn Street, Beacon Hill, Boston, Massachusetts, USA" },
  { file: "nassau.jpeg", alt: "Nassau Hall (Old Nassau), Princeton, New Jersey, USA" },
  { file: "tufts.jpeg", alt: "Tufts University, Medford, Massachusetts, USA" },
  { file: "forsyth.jpeg", alt: "Forsyth Park, Savannah, Georgia, USA" },
  { file: "govmansion.jpeg", alt: "Old Governor's Mansion, Milledgeville, Georgia, USA" },
  { file: "deltaflightmuseum.jpeg", alt: "Delta Flight Museum, Atlanta, Georgia, USA" },
  { file: "denver.jpeg", alt: "Writer Square, Denver, Colorado, USA" },
  { file: "asakusa.jpeg", alt: "Senso-ji Five Story Pagoda, Asakusa, Tokyo, Japan" },
  { file: "tokyo_skytree.jpeg", alt: "Tokyo Skytree, Sumida, Tokyo, Japan" },
  { file: "fushimi_inari_shrine.jpeg", alt: "Fushimi Inari Shrine, Kyoto, Japan" },
  { file: "imperial_palace.jpeg", alt: "Imperial Palace, Kyoto, Japan" },
  { file: "kinkakuji.jpeg", alt: "Kinkaku-ji (Golden Pavilion), Kyoto, Japan" },
  { file: "birdrock.jpeg", alt: "Bird Rock, La Jolla, California, USA" },
  { file: "scripps_pier.jpeg", alt: "Scripps Pier, La Jolla, California, USA" },
  { file: "torrey_pines_state_park.jpeg", alt: "Torrey Pines State Park, La Jolla, California, USA" },
  { file: "times_square.jpeg", alt: "Times Square, New York City, New York, USA" },
  { file: "excalibur_new_york_new_york.jpeg", alt: "Excalibur and New York New York Hotel and Casino, Las Vegas, Nevada, USA" },
  { file: "pacific_beach.jpeg", alt: "Pacific Beach, San Diego, California, USA" },
];

const requireImage = require.context('../img', false);

const images = imageData.map(({ file, alt }) => ({
  src: requireImage(`./${file}`).default,
  alt,
}));

const Carousel = () => {
  // Random starting index
  const randomIndex = Math.floor(Math.random() * images.length);
  const [currentIndex, setCurrentIndex] = useState(randomIndex);

  const goToPrevious = () => {
    const isFirst = currentIndex === 0;
    setCurrentIndex(isFirst ? images.length - 1 : currentIndex - 1);
  };

  const goToNext = () => {
    const isLast = currentIndex === images.length - 1;
    setCurrentIndex(isLast ? 0 : currentIndex + 1);
  };

  // Auto-advance every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      goToNext();
    }, 7500); // 7500ms = 7.5 seconds

    return () => clearInterval(timer); // Clean up interval on unmount
  }, [currentIndex]);

  return (
    <div className="carousel-container">
      <h2>Photos</h2>
      <h3>Thanks for stopping by!</h3>
      <h3>Please enjoy some of the photos I have taken on my travels!</h3>

      <div className="carousel">
        <button onClick={goToPrevious} className="nav-button">❮</button>

        <img 
          src={images[currentIndex].src} 
          alt={images[currentIndex].alt} 
          className="carousel-image" 
        />

        <button onClick={goToNext} className="nav-button">❯</button>
      </div>

      <p>{images[currentIndex].alt}</p>
    </div>
  );
}

export default Carousel;